import { provideNzIcons } from 'ng-zorro-antd/icon';
import { IcIcons } from 'libs/core/src/lib/configs/icons';
import { importProvidersFrom, provideZoneChangeDetection } from '@angular/core';

import { AuthService } from 'libs/core/src/lib/services/auth.service';
import { IcHttpConfigInterceptor } from 'libs/core/src/lib/interceptors/ic-http-interceptor.interceptor';
import { provideDarkMode } from 'libs/core/src/lib/services/dark-mode.service';
import { providePortalName } from 'libs/core/src/lib/services/notice.service';
import { provideImpersonationMode } from 'libs/core/src/lib/services/impersonation.service';
import { provideImpersonationReadOnlyMode } from 'libs/core/src/lib/interceptors/impersonation-read-only.interceptor';
import { IReceiptsInjectionToken } from 'libs/core/src/lib/services/shared-receipt.service';
import { IUsersServiceInjectionToken } from 'libs/core/src/lib/services/users.service';
import { provideTenantTheme } from 'libs/core/src/lib/services/tenant-config.service';
import { RouteTitleStrategy } from 'libs/core/src/lib/route-title-stratagy';
import { en_US, NZ_I18N } from 'ng-zorro-antd/i18n';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzModalService } from 'ng-zorro-antd/modal';
import { AgentReceiptsService } from './app/services/agent-receipts.service';
import { AgentUsersService } from './app/services/agent-users.service';
import { AgentAuthService } from './app/services/agent-auth-service';
import { provideRouter, Route, TitleStrategy } from '@angular/router';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { resolveRepresentative } from './app/agent.resolver';
import { loginGuard } from './app/login.guard';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr
} from '@angular/common/http';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { NgHttpCachingModule } from 'ng-http-caching';
import { IcHttpCachingConfig } from 'libs/core/src/lib/configs/http-cache';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { AppComponent } from './app/app.component';
import {
  initializeSentry,
  provideSentryTracing,
} from '../../../libs/core/src/lib/sentry';
import { provideNzDateFnsAdapter } from 'ng-zorro-antd/core/time';


const routes: Route[] = [
  {
    path: '',
    loadChildren: () =>
      import('libs/shared-modules/src/lib/login/login.module').then((m) => m.LoginModule),
    title: 'Login',
    data: { portal: 'Agent portal' },
  },
  {
    path: 'dashboard',
    resolve: { resolvedData: resolveRepresentative },
    canActivate: [loginGuard],
    loadChildren: () =>
      import('./app/dashboard/dashboard.module').then((m) => m.DashboardModule),
  },
];
initializeSentry('Agents Portal');

bootstrapApplication(AppComponent, {
  providers: [
    providePortalName('agents-portal'),
    provideNzIcons(IcIcons),
    provideZoneChangeDetection(),
    importProvidersFrom(
      BrowserModule,
      FormsModule,
      LoadingBarModule,
      LoadingBarHttpClientModule,
      NgHttpCachingModule.forRoot(IcHttpCachingConfig),
      LoadingBarRouterModule,
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: IcHttpConfigInterceptor,
      multi: true,
    },
    { provide: NZ_I18N, useValue: en_US },
    { provide: NzNotificationService },
    { provide: NzModalService },
    { provide: TitleStrategy, useClass: RouteTitleStrategy },
    {
      provide: IReceiptsInjectionToken,
      useClass: AgentReceiptsService,
    },
    {
      provide: IUsersServiceInjectionToken,
      useClass: AgentUsersService,
    },
    {
      provide: AuthService,
      useClass: AgentAuthService,
    },
    provideImpersonationMode(),
    provideImpersonationReadOnlyMode(),
    provideTenantTheme(),
    provideDarkMode(),
    provideRouter(routes),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
     provideSentryTracing(), provideNzDateFnsAdapter(),
  ],
}).catch((err) => console.error());
